import React, { useState } from 'react'
import { Card, CardBody, Form, FormGroup, Label, Input, Button, Row, Col, Container } from 'reactstrap'
import Editor from '../../Components/Form/Editor/Editor'
import Breadcrumb from 'Components/UI/Breadcrumb'

function EmailTemplate() {
  const [subject, setSubject] = useState('')
  const [recipient, setRecipient] = useState('')
  const [content, setContent] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: Handle form submission
    console.log({ subject, recipient, content })
  }

  return (
    <div className="page-content">
      <Container fluid>
      <Breadcrumb items={[{ label: "Email Template"}]} />
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">Email Template</h4>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={12}>
                <FormGroup className="mb-3">
                  <Label htmlFor="subject">Subject</Label>
                  <Input
                    id="subject"
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Enter email subject"
                    required
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="recipient">Recipient</Label>
                  <Input
                    id="recipient"
                    type="email"
                    value={recipient}
                    onChange={(e) => setRecipient(e.target.value)}
                    placeholder="Enter recipient email"
                    required
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Email Content</Label>
                  <Editor content={content} setContent={setContent} />
                </FormGroup>

                <div className="text-end mt-3">
                  <Button type="submit" color="primary">
                    Save Template
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
      </Container>
    </div>
  )
}

export default EmailTemplate
